import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import MainScreen from './main-screen'
import {setCurrentGameType} from '../../ducks/duck-game';
import {addModalWindow} from "../../ducks/duck-screen";

function MainScreenContainer(props) {
	return (
		<MainScreen {...props} />
	);
}

MainScreenContainer.propTypes = {
	push: PropTypes.func.isRequired,
	addModalWindow: PropTypes.func.isRequired,
};

export default connect(null, {
	setCurrentGameType,
	addModalWindow
})(MainScreenContainer);
